// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPhoneIncoming = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16.922 8.928l5.392-5.392-1.415-1.414-5.391 5.391-.265-3.977-1.768 1.768.354 5.303 5.303.354 1.767-1.768z" />,
    <path
      fillRule="evenodd"
      d="M6.986 5H1v1c0 4.804 1.654 9.063 4.641 12.127C8.631 21.194 12.898 23 18 23h1v-5.986l-3.042-3.042-4.715 1.857-3.072-3.072 1.857-4.715zm.087 11.73C4.69 14.287 3.238 10.915 3.027 7h3.13l1.53 1.53-1.858 4.714 4.928 4.927 4.714-1.857L17 17.843v3.131c-4.154-.217-7.535-1.79-9.927-4.244"
    />
  );
export default SvgIconPhoneIncoming;
